import React, { useState } from "react";
import { FileJson, Upload, Rocket } from "lucide-react";
import { toast } from "sonner";
import { db } from "@/api/base44Client";

export function JsonImportPanel({ onImported }) {
  const [jsonInput, setJsonInput] = useState("");
  const [fileName, setFileName] = useState("");
  const [status, setStatus] = useState("");
  const [busy, setBusy] = useState(false);

  const handleFileUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setFileName(file.name);
    const reader = new FileReader();
    reader.onload = (ev) => setJsonInput(ev.target.result);
    reader.readAsText(file);
  };

  const handleImport = async () => {
    let parsed;
    try { parsed = JSON.parse(jsonInput); } catch { setStatus("Fehler beim Parsen. Bitte JSON-Format prüfen."); return; }
    const questions = Array.isArray(parsed) ? parsed : parsed?.questions;
    if (!Array.isArray(questions)) { setStatus("Das Format muss ein Array von Fragen sein ([...])"); return; }
    setBusy(true); setStatus(`Importiere ${questions.length} Fragen...`);
    try {
      const r = await db.admin.importQuestions(questions);
      setStatus(`Erfolgreich ${r.imported} Fragen importiert${r.skipped ? ` (${r.skipped} übersprungen)` : ""}!`);
      toast.success(`${r.imported} Fragen importiert`);
      setJsonInput(""); setFileName("");
      onImported();
    } catch (e) { setStatus(`Fehler beim Importieren: ${e?.response?.data?.detail || e.message}`); } finally { setBusy(false); }
  };

  return (
    <section className="adm-card" data-testid="admin-json-import">
      <div className="adm-card-head">
        <div>
          <h2 className="adm-card-title"><span className="adm-card-icon"><FileJson className="h-4 w-4" /></span>Admin-Import (Fragen-Datenbank befüllen)</h2>
          <p className="adm-muted" style={{ marginTop: "0.5rem" }}>Lade eine JSON-Datei hoch oder füge den JSON-Code ein, um deine Fragen direkt in die Datenbank zu importieren.</p>
        </div>
      </div>
      <div className="adm-grid">
        <span className="adm-label">JSON-Datei hochladen</span>
        <label className="adm-drop" data-testid="admin-import-file-label">
          <Upload className="h-5 w-5" />
          <span style={{ fontSize: "0.85rem", fontWeight: 700 }}>{fileName || "Datei auswählen (.json, .txt)"}</span>
          <input type="file" accept=".json,.txt" className="hidden" onChange={handleFileUpload} data-testid="admin-import-file-input" />
        </label>
        <label className="adm-field"><span className="adm-label">Oder JSON-Code direkt einfügen</span>
          <textarea rows={6} className="adm-input" data-testid="admin-import-textarea" value={jsonInput} onChange={(e) => setJsonInput(e.target.value)}
            placeholder='[{"question": "...", "options": [...], "correct": 0, "subject": "...", "profession": "..."}]' /></label>
      </div>
      <button className="adm-btn adm-btn-block" disabled={busy || !jsonInput.trim()} onClick={handleImport} data-testid="admin-import-submit"><Rocket className="h-4 w-4" /> Fragen jetzt in Datenbank importieren</button>
      {status && <p className="adm-status" data-testid="admin-import-status">{status}</p>}
    </section>
  );
}
